export enum QuestionTypes {
  "Booleana" = 1,
  "Quantitativa" = 2,
  "Descritiva" = 3,
  "Avaliativa" = 4,
  "Criticidade" = 5,
  "Lista Simples" = 6,
  "Lista Dinâmica" = 7,
  "Assinatura" = 8,
  "Operação" = 9,
  "QR Code" = 10,
  "Tabela de Medidas" = 11,
}

export enum QuestionTypesTranslation {
  "boolean"= 1,
  "quantitative"= 2,
  "descriptive"= 3,
  "evaluative"= 4,
  "criticality"= 5,
  "simple_list"= 6,
  "dynamic_list"= 7,
  "signature"= 8,
  "operation"= 9,
  "bar_code_or_qr" = 10,
  "measure_table_type" = 11,
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/enum/question-type.ts